import { UserEditForm } from "../components/user/UserEditForm";
import { useAuthStore } from "../store/auth.store";
import React, {useEffect, useMemo, useState} from "react";
import { Tabs, Tab, Stack } from "@mui/material";
import { ProposalsTable } from "../components/proposal/ProposalsTable";
import { useNavigate } from "react-router";
import {parseQueryParams, removeQueryParam} from "../utils/UrlUtils";
import {SupportTicketsTable} from "../components/support/SupportTicketsTable";
import {enqueueSnackbar} from "notistack";

export function ProfilePage() {
    const authStore = useAuthStore();
    const {jwt, setShowLogin, showLogin } = authStore;

    const defaultTab:"profile"|"fav"|"my"|"tickets" = useMemo(() => {
        const tab = parseQueryParams(document.location.toString()).tab || 'profile';
        if(['profile', 'fav', 'my'].indexOf(tab) === -1) {
            return 'profile'
        }
        return tab as "profile"|"fav"|"my"|"tickets";
    }, [])
    useEffect(() => {
        return () => removeQueryParam("tab")
    }, []);

    const [tab, setTab] = useState<'profile' | 'fav' | 'my' | "tickets">(defaultTab);
    const [idToEdit, setIdToEdit] = useState('');

    const navigate = useNavigate();
    useEffect(() => {
        if(!jwt && !showLogin) {
            setShowLogin(true);
        }
    }, [jwt, setShowLogin, showLogin]);

    if(!authStore.user?.id) {
        return null
    }
    return <div>
        {!idToEdit && <Stack alignItems="center" direction="column" className={"mb-15"}>
            <Tabs style={{maxWidth: 800}} value={tab} onChange={(e, newValue) => setTab(newValue)}>
                <Tab value={'profile'} label={"Profile"}/>
                <Tab value={'my'} label={"My Proposals"} />
                {authStore.can("see_premium") && <Tab value={'fav'} label={"Favorite"} />}
                <Tab value={'tickets'} label={"Support"} />
            </Tabs>
        </Stack>}
        {tab === 'profile' && <UserEditForm onSave={() => enqueueSnackbar({message: "Profile data updated", variant: 'success'})} id={authStore.user.id} parent={"/"} hideBack={true} />}
        {tab === 'my' && <ProposalsTable
            createNew={() => setIdToEdit("new")}
            onIdToEdit={(id) => setIdToEdit(id)}
            idToEdit={idToEdit}
            hideMy={true}
            goBack={() => {setIdToEdit('');navigate("/profile")}}
            processFilter={(filter) => ({...filter, my: true})}/>}
        {authStore.can('see_premium') && tab === 'fav' && <ProposalsTable
            createNew={() => setIdToEdit("new")}
            onIdToEdit={(id) => {setIdToEdit(id);}}
            idToEdit={idToEdit}
            hideFavorite={true}
            goBack={() => {setIdToEdit('');navigate("/profile")}}
            processFilter={(filter) => ({...filter, favorite: true})}/>}
        {tab === 'tickets' && <SupportTicketsTable goBack={() => navigate("/profile")} />}
    </div>
}